export interface OpeningHours {
  day: string;
  hours: string;
}

export const openingHours: OpeningHours[] = [
  { day: 'Lundi', hours: '09h00 - 19h00' },
  { day: 'Mardi', hours: '09h00 - 19h00' },
  { day: 'Mercredi', hours: '09h00 - 19h00' },
  { day: 'Jeudi', hours: '09h00 - 19h00' },
  { day: 'Vendredi', hours: '09h00 - 20h00' },
  { day: 'Samedi', hours: '09h00 - 20h00' },
  { day: 'Dimanche', hours: 'Fermé' },
];